import { render, staticRenderFns } from "./NsModal.vue?vue&type=template&id=e668750e&scoped=true&"
import script from "./NsModal.vue?vue&type=script&lang=js&"
export * from "./NsModal.vue?vue&type=script&lang=js&"
import style0 from "./NsModal.vue?vue&type=style&index=0&id=e668750e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e668750e",
  null
  
)

export default component.exports